<template>
    <div class="courseView">

      <div class="headerView">
        <!-- 全部/关注 -->
        <div class="tabs">
          <span :class="`tab ${work_type === 'applab' ? 'tab--select' : ''}`" @click="setType('applab')">AppLab</span>
          <span :class="`tab ${work_type === 'scratch' ? 'tab--select' : ''}`" @click="setType('scratch')">Scratch</span>
        </div>
      </div>

      <div class="items">
        <div class="item" v-for="(item, index) in applab_data" :key="item.pk">
          <WorkItem :dic="item" :data-type="data_type"/>
        </div>
      </div>
        
    </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from "@/utils";

import WorkItem from "./scratch/components/WorkItem.vue";

import { types as WorkTypes } from "@/store/modules/work";
import { types as CompanyTypes } from "@/store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "AppStoreHome",
  components: {
    WorkItem
  },
  data() {
    return {
      work_type: 'applab',
      data_type: 'top_applab'
    };
  },
  computed: {
    ...mapState({
      applab_page: state => state.work.applab_data.page,
      applab_load_more: state => state.work.applab_data.load_more,
      applab_data: state => state.work.applab_data.data,
    })
  },

  methods: {
    ...mapActions({
      fetchWorksData: WorkTypes.FETCH_LIST_MY_WORKS,
      fetchLikeWorkEvent: WorkTypes.FETCH_LIKE_EVENT,
      fetchDeleteWorkEvent: WorkTypes.FETCH_DELETE_WORK,
      fetchCreateProduct:CompanyTypes.FETCH_PRODUCT_CREATE,
    }),
    
    ...Utils,

    // 设置作品类型
    setType (type) {
      if(type === this.work_type) return;
      document.documentElement.scrollTop = 0
      this.work_type = type;
      // 重新请求数据
      this.load_data("", 1, false);
    },

    load_data(tag="", pagenum, loadmore){
      let page = pagenum ? pagenum : this.applab_page;
      let load_more = loadmore ? loadmore : this.applab_load_more;

      if(tag === "next"){
        if(load_more){
          console.log("请求下一页数据")
          page += 1
        }else{
          console.log("无法请求下一页数据")
          return
        }
      }
      
      let dic = {
        page: page,
        data_type: this.data_type,
        top: true,
        page_size:20
      }
      if(this.work_type === 'applab'){
        // 请求 applab 精选数据
        dic["work_type"] = "applab"
        this.fetchWorksData(dic);
      }else if(this.work_type === 'scratch'){
        // 请求 scratch3 精选数据
        dic["work_type"] = "scratch3"
        this.fetchWorksData(dic);
      }
    },
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }

      // console.log("作品列表:", height, scrollHeight, scrollTop);
      // console.log(height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        that.load_data("next")
      } else {
        console.log("没到底部");
      }
    },

    // --------------workItem 组件回调事件
    //点赞作品
    likeWorkEvent(item) {
      this.fetchLikeWorkEvent({pk:item.pk, data_type: this.data_type});
    },
    //作品详情页
    jumpToWorkDetail(item) {
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${item.pk}`,
        "_blank"
      );
    },
    // 将作品放到公司产品中
    sendToCompanyEvent(item){
      this.fetchCreateProduct({"showwork_id":item.pk})
    },
    // 删除作品
    deleteWork(item){
      this.fetchDeleteWorkEvent({pk:item.pk, data_type: this.data_type});
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.load_data("", 1, false);
  }
};
</script>

<style lang="less" scoped>
.courseView {
  background-color: #f8f8f8;
  border-radius: 4px;
  padding: 10px;
  min-height: 500px;

  .items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px 0;
    margin-left: -10px;
    margin-bottom: 0;
    min-height: 120px;
    .item {
      width: calc(100% / 3 - 12px);
      margin-left: 10px;
      margin-bottom: 10px;
      border: solid 1px #ebebeb;
      cursor: pointer;
      background-color: #ffffff;
      border-radius: 4px;
      overflow: hidden;
      &.four_item{
        width: calc(100% / 4 - 12px);
      }
    }
  }
}
.headerView{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 15px 0;
  .tabs {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    // padding-top: 18px;
    // margin-left: -120px;
    .tab {
      color: #666666;
      font-size: 15px;
      margin-left: 15px;
      margin-right: 15px;
      padding-bottom: 3px;
      cursor: pointer;
    }
    .tab--select {
      color: #ff7b00;
      border-bottom: solid 1.5px #f56501;
      font-weight: bold;
    }
  }
  

}
</style>
